<template>
  <swiper ref="menuSwiper" :options="swiperOptions">
    <swiper-slide
      v-for="(item, index) in datas"
      :key="index"
      @click.native="clickSwiper(index)"
    >
      <div class="baner">
        <p :class="{ active: currentIndex === index }">{{ item.content }}</p>
      </div>
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import Vue from 'vue'
import vueSwiper from 'vue-awesome-swiper'
Vue.use(vueSwiper)

export default {
  name: 'menuSwiper',
  data: function() {
    return {
      currentIndex: 0,
      swiperOptions: {
        slidesPerView: 3.5,
        preventClicks: false
      }
    }
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    datas() {
      var result = [
        {
          content: '全部',
          idx: 0
        },
        {
          content: '备孕指南',
          idx: 1
        },
        {
          content: '避孕指南',
          idx: 2
        },
        {
          content: '孕妇生活',
          idx: 3
        },
        {
          content: '产后护理',
          idx: 4
        }
      ]
      return result
    }
  },
  // 初始化，必须在 挂载阶段。
  mounted() {
    // console.log('Current Swiper instance object', this.swiper)
  },
  methods: {
    clickSwiper(index) {
      this.currentIndex = index
      let obj = this.datas[index]
      this.$parent.switchSwiper(obj.idx || 0)
    }
  }
}
</script>
<style scoped>
.baner {
  width: auto;
  height: 50px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ebebeb;
}
.baner .img {
  width: 100%;
  height: 40px;
  text-align: center;
}

.baner .img img {
  width: 40px;
  height: 40px;
}
.baner p {
  width: auto;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 14px;
  text-align: center;
  margin: auto;
  padding-bottom: 8px;
}

p.active {
  font-size: 15px;
  color: #ff7486;
  border-bottom: 2px solid #ff7486;
}
.active {
  color: #333333 !important;
  font-size: 16px !important;
  font-family: PingFang SC !important;
  font-weight: 600 !important;
}
</style>

<style src="./css/swiper.min.css"></style>
